import React, { useState } from 'react';

import './Reports.scss';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col  } from '@cfa/react-components';
import { IField } from './ReportsModel';
import { allFields } from './Loaders';

interface IColumnPickerModalProps {
    show: boolean,
    visibleColumns: IField[],
    setVisibleColumns: (newVisibleColumns: IField[]) => void,
    onHide: () => void
}

export function ColumnPickerModal({ show, visibleColumns, setVisibleColumns, onHide }: IColumnPickerModalProps) {

    const [selected, setSelected] = useState<IField[]>(visibleColumns);
    const isSelected = input => selected.some(({id}) => id == input);

    const onSelectColumn = (col: IField) => {
        let newSelected = selected.slice();
        
        if (isSelected(col.id)) newSelected.splice(newSelected.findIndex(c => c.id === col.id), 1);
        else newSelected.push(col);

        setSelected(newSelected);
    }

    return (
        <Modal show={show} onClose={onHide} scrollMode="modal-body">

            <ModalHeader>
                Select Visible Columns
            </ModalHeader>

            <ModalBody style={{
                maxHeight: 'calc(100vh - 210px)',
                overflowY: 'auto'
            }}>
                <div>
                    {allFields.map(column => (
                        <div key={column.id}>
                            <Row>
                                <Col style={{textAlign: "left"}}>
                                    {column.label}
                                </Col>
                                <Col lg={3}>
                                    <label className="columnPicker_switch">
                                        <input 
                                            type="checkbox"
                                            onChange={() => onSelectColumn(column)}
                                            checked={isSelected(column.id)}
                                        />
                                        <span className="columnPicker_slider"></span>
                                    </label>
                                </Col>
                            </Row>
                        </div>
                    ))}
                </div>
            </ModalBody>

            <ModalFooter>
                <Button variant="outlined" onClick={onHide}>
                    Close
                </Button>
                <Button onClick={() => setVisibleColumns(selected)}>
                    Save
                </Button>
            </ModalFooter>

        </Modal>
    );
}